
import { defineComponent } from 'vue'

export default defineComponent({
    name: "NavbarSection",

    data(){
        return{
            standardOffset: 0, // Scroll offset in px
            sectionOutOffset: 0, // Standard scroll offset + section-out top value
            scrollOffset: 0
        }
    },

    mounted(){

        this.linkToSection();
        
        this.adjustTargetPosition();
        window.addEventListener("resize", this.adjustTargetPosition);

    },

    methods:{

        adjustTargetPosition(){

            if (window.innerWidth <= 768){      // Mobile
                this.standardOffset = 48;
                this.sectionOutOffset = 150 + 48;
            } else {                            // Desktop
                this.standardOffset = 150;
                this.sectionOutOffset = 300;
            }

        },

        linkToSection(){

            const navLinks = document.querySelectorAll(".nav-link-section");

            navLinks.forEach((navLink) => {
                navLink.addEventListener("click", () => {

                    // Scroll-behavior:smooth; on html is not compatible with the auto scroll hero code, so the nav links have to work this way

                    // Get the target ID
                    const linkTo = navLink.getAttribute("linkTo");
                    const targetElem = document.querySelector(linkTo as string);

                    // Scroll to the target
                    if (targetElem){

                        if (targetElem.classList.contains("section-out")){
                            this.scrollOffset = this.sectionOutOffset;
                        } else {
                            this.scrollOffset = this.standardOffset;
                        }

                        // Deactivate the Hero section auto scroll for a short time
                        this.deactivHeroAutoScroll();

                        // Smooth scroll to the section
                        window.scrollTo({
                            top: this.topPosition(targetElem),
                            behavior: "smooth"
                        });
                
                        // Get the updated position (section lazy loading on click)
                        setTimeout(() => {
                            window.scrollTo({
                                top: this.topPosition(targetElem),
                                behavior: "smooth"
                            });
                        }, 10);
           

                    }

                });
            });

        },

        topPosition(targetElem: Element){

            const topPosition = 
                targetElem.getBoundingClientRect().top + 
                window.pageYOffset - 
                this.scrollOffset;

            return topPosition;

        },

        deactivHeroAutoScroll(){

            document.body.classList.add("nav-link-clicked");

            // To make sure it's past the Hero section auto-scroll activation point
            setTimeout(() => {
                document.body.classList.remove("nav-link-clicked");
            }, 350);

        }

    }

});
